// removed by extract-text-webpack-plugin
module.exports = {"divider":"NLX6"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/components/OrDivider/OrDivider.scss
// module id = 7MNA
// module chunks = 0